import { format2DateStr } from '@/utils/date';
import getRandomId from '@/utils/uuid';
import checkInService from '@/api/checkIn';
import {
  MainState,
  ReducerState,
  RenewalRentRoomInfo,
} from '@/redux/reducers/reservation/directRenewal';
import { parseFen2Yuan } from '@/utils/number';

// 获取续住单详情
export const getStateFromOrder: (params) => Promise<MainState> = async (params) => {
  const res = await checkInService.getExtensionOrderSummary(params);
  const { sourceOrder, targetOrder } = res.data;
  const sourceOrderList = sourceOrder.subOrders;
  const targetOrderList = targetOrder.subOrders;

  const rentRoomInfos: RenewalRentRoomInfo[] = []; // 入住房间

  const occNamMap = {}; // 入住人姓名
  const formatNameInfo = (list) => {
    list.forEach((item) => {
      occNamMap[item.wyuId] = item.name;
    });
  };

  const targetRoomTypeMap: Record<string, RenewalRentRoomInfo[]> = {};
  const targetRoomMap: Record<string, RenewalRentRoomInfo> = {};

  targetOrderList.forEach((roomItem: RenewalRentRoomInfo) => {
    const { roomTypeId } = roomItem;
    const indexId = getRandomId();
    const roomList = targetRoomTypeMap[roomTypeId] || [];
    const roomInfo = {
      ...roomItem,
      indexId,
      roomPriceList: (roomItem.roomPriceList || []).map((priceItem) => {
        return {
          ...priceItem,
          rentDate: format2DateStr(priceItem.rentDate),
          couponValue: parseFen2Yuan(priceItem.couponAmount),
        };
      }),
    };
    roomList.push(roomInfo);
    targetRoomTypeMap[roomTypeId] = roomList;
    targetRoomMap[indexId] = roomInfo;
  });

  sourceOrderList.forEach((roomItem) => {
    const { roomTypeId, occInfoList } = roomItem;
    const guestList = occInfoList || [];
    formatNameInfo(guestList);
    const targetRoom = targetRoomTypeMap[roomTypeId].shift();
    rentRoomInfos.push({
      ...roomItem,
      indexId: getRandomId(),
      guestNames: guestList.map((item) => occNamMap[item.wyuId]).join(','),
      targetId: targetRoom.indexId,
      roomPriceList: [],
    });
  });

  const targetOrderInfo = targetOrder || {};

  return {
    customerInfo: {
      name: targetOrderInfo.name,
      mobile: targetOrderInfo.mobile,
      otaOrderNo: targetOrderInfo.otaOrderNo,
      email: targetOrderInfo.email,
      balance: targetOrderInfo.balance,
    },
    rentRoomInfos,
    targetRoomMap,
    remarkInfo: {
      remark: targetOrderList[0].remark,
      checkInRemark: sourceOrderList[0].checkinRemark,
    },
  };
};

// 提交数据
export const formatToSubmitData: (data: ReducerState) => { [key: string]: unknown } = (data) => {
  const { rentRoomInfos, targetRoomMap } = data;
  return {
    zlExtensionDataVOS: rentRoomInfos.map((item) => {
      const targetRoomInfo = targetRoomMap[item.targetId];
      return {
        recNo: item.recNo,
        zlRecNo: targetRoomInfo.recNo,
      };
    }),
  };
};
